import { useNavigate } from 'react-router-dom';

import InviteFriendsPage, {
  CompetitionType,
} from '../inviteFriends/InviteFriendsPage';

// import useMinileague from '@/hooks/useMinileague';
import { useMinileagueData } from '@/hooks/useMinileagueData';
import useTourney from '@/hooks/useTourney';
import ROUTES from '@/router/routes';
import { suggestUsersToInvite } from '@/services/invites';
import {
  inviteByEmail,
  inviteUserById,
  searchDtsByName,
} from '@/services/minileagues';
import { SECTION_NAME_FOR_ADS } from '@/utils/ads';

function MinileaguesInvitePage() {
  const { tourneyData, handleSetTourney } = useTourney();
  const { miniligueData } = useMinileagueData();

  const navigate = useNavigate();

  const minileagueServices = {
    inviteByEmail,
    inviteById: inviteUserById,
    suggestUsers: suggestUsersToInvite,
    searchByName: searchDtsByName,
  };

  const handleNavigateToMinileague = () => {
    handleSetTourney({
      ...tourneyData,
      id: tourneyData.id,
    });
    navigate(ROUTES.minileagues.admin, {
      state: { minileagueId: miniligueData.miniLiga.id },
    });
  };

  return (
    <InviteFriendsPage
      adsSections={SECTION_NAME_FOR_ADS.miniligas}
      competitionId={miniligueData.miniLiga.id ? miniligueData.miniLiga.id : 0}
      redirectRoute={handleNavigateToMinileague}
      services={minileagueServices}
      type={CompetitionType.MINILEAGUES}
    />
  );
}

export default MinileaguesInvitePage;
